<mat-form-field  [class]="ShowTime ? 'half-width' : 'full-width'">
  <input matInput [min]="minDate" [max]="maxDate" (click)="picker.open()" [placeholder]="placeholder | localize" readonly [ngModel]="Date" [matDatepicker]="picker" (dateChange)="changeDate($event.value)"/>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>

</mat-form-field>
<input  type="time" *ngIf="ShowTime" [(ngModel)]="time" (ngModelChange)="timeChanged()" class="time-picker" >


